import type { PaginationType } from '~/model/PaginationType';

export function isPaginationHasMorePage(pagination: PaginationType) {
  return pagination && getPaginationNextPage(pagination) !== undefined;
}

export function getPaginationNextPage(pagination: PaginationType) {
  return pagination?.['hydra:next'];
}
export function getPaginationNextPageNumber(pagination: PaginationType) {
  return pagination
    && getPaginationNextPage(pagination)
    && Number.parseInt(getPaginationNextPage(pagination).split('=').pop(), 10);
}
